export const capitalizeFirstLetter = (text: string): string => {
  if (text && text.toString().length > 0) {
    return text.charAt(0).toUpperCase() + text.slice(1)
  } else {
    return ''
  }
}

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}

export const pluralize = (quantity: number, word: string) => {
  if (quantity > 1) {
    return `${word}s`
  } else {
    return word
  }
}

export const toKebabCase = (str: string) => str.replace(/\s+/g, '-').toLowerCase()

export default {
  pluralize,
  capitalizeFirstLetter,
  toKebabCase,
  copyToClipboard
}
